/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFeesV1FeeRateEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FEES_V1_FEE_RATE_EVENT_ENTITY_NAME = 'ixc.fees.v1.FeeRateEvent';
export const ixcFeesV1FeeRateEventEntity = new schema.Entity<IxcFeesV1FeeRateEvent>(IXC_FEES_V1_FEE_RATE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcFeesV1FeeRateEvent) => `${entity.metadata?.eventId}` });

